import type { RasterSelectionUiState } from "../../selection/selectionTypes";

interface SelectionInspectorProps {
  destructiveAllowed?: boolean;
  selection: RasterSelectionUiState;
  onApply: () => void;
  onDelete: () => void;
  onDeselect: () => void;
  onDuplicate: () => void;
  onFlipHorizontal: () => void;
  onFlipVertical: () => void;
}

export function SelectionInspector({
  selection,
  onApply,
  onDelete,
  onDeselect,
  onDuplicate,
  onFlipHorizontal,
  onFlipVertical,
  destructiveAllowed = true,
}: SelectionInspectorProps) {
  const disabled = !selection.hasSelection || selection.isTransforming;
  return (
    <section className="selection-inspector" aria-label="Selected raster art">
      <div className="selection-inspector__summary" aria-live="polite">
        <strong>Selected art</strong>
        <span>
          {selection.bounds
            ? `${selection.bounds.width} x ${selection.bounds.height} pixels`
            : "No selection"}
        </span>
      </div>
      <div className="selection-inspector__actions" role="toolbar" aria-label="Selection actions">
        <button disabled={!selection.isTransforming} onClick={onApply} type="button">
          Apply
        </button>
        <button disabled={disabled} onClick={onDuplicate} type="button">
          Duplicate
        </button>
        <button
          aria-label="Flip selected art horizontally"
          disabled={disabled}
          onClick={onFlipHorizontal}
          type="button"
        >
          Flip horizontal
        </button>
        <button
          aria-label="Flip selected art vertically"
          disabled={disabled}
          onClick={onFlipVertical}
          type="button"
        >
          Flip vertical
        </button>
        <button
          className="selection-inspector__delete"
          disabled={disabled || !destructiveAllowed}
          onClick={onDelete}
          type="button"
        >
          Delete selected art
        </button>
        <button disabled={!selection.hasSelection} onClick={onDeselect} type="button">
          Deselect
        </button>
      </div>
    </section>
  );
}
